import { render, staticRenderFns } from "./Customization.vue?vue&type=template&id=0e8d3e6c&scoped=true&"
import script from "./Customization.vue?vue&type=script&lang=ts&"
export * from "./Customization.vue?vue&type=script&lang=ts&"
import style0 from "./Customization.vue?vue&type=style&index=0&id=0e8d3e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d3e6c",
  null
  
)

export default component.exports